<template>
  <div id="bottomNavigation" ref="bottomNavigation">
    <div class="itembox" :style="{height: tabHeight+'px'}">
      <div @click="ChangeTabGO(index)" :class="['allItem',item.active?'active':'']" v-for="(item,index) in iconList"
        :key="index">
        <div class="ItemImg" :style="{backgroundImage: 'url('+item.images+')'}"></div>
        <p class="ItemText">{{item.name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
// import EventBus from '../../bus.js'
export default {
  props: ['tab',"viewName"],
  watch: {
    
    tab: {
      handler (newVal, oldVal) {
        this.ChangeTabGO(oldVal === newVal ? oldVal : newVal,"watch")
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      iconList: [
        {
          images: require('../assets/allItem.png'),
          name: '全部商品',
          active: false
        },
        {
          images: require('../assets/shoppingCart.png'),
          name: '购物车',
          active: false
        },
        {
          images: require('../assets/myCenter.png'),
          name: '我的',
          active: false
        }
      ],
      islogin: '',
      tabHeight: 50
    }
  },
  methods: {
    checkLogin () {
      this.utils.isUserLogin((login) => {
        if (login === 1) {
          this.utils.get(this.companyUrl + '/ent/json', null, res => {
            localStorage.setItem('userinfo', JSON.stringify(res.data))
          })
        }
      })
    },
    backTohome () {
      if (localStorage.getItem('tab') == 0) {
        return '0'
        // window.zxzx.finish(0)
      } else {
        this.ChangeTabGO(0,"backTohome")
        return '1'
      }
    },
    ChangeTabGO (i,com) {
      this.iconList = [
        {
          images: require('../assets/allItem.png'),
          name: '全部商品',
          active: false
        },
        {
          images: require('../assets/shoppingCart.png'),
          name: '购物车',
          active: false
        },
        {
          images: require('../assets/myCenter.png'),
          name: '我的',
          active: false
        }
      ]
      this.iconList.forEach((item, index) => {
        if (index === i) {
          item.active = true
          switch (i) {
            case 0:
              // 参数
              let url = window.location.href
              if (url.indexOf('homePage/goodslist') >= 0 && url.indexOf('?') >= 0) {
                let param = url.split('?')[1]
                localStorage.setItem('homeParam', '?' + param)
              }
              var param = localStorage.getItem('homeParam')
              if (param == null || param === undefined) {
                param = ''
              }
              item.images = require('../assets/allItem_active.png')
              this.$router.replace({
                path: '/homePage/goodslist' + param
              }).catch(err => { return err }) // vue-router在3.1后将push改成了promise,所以需要一个回调
              // 因页面缓存 需重置所需设置
              this.resetSet()
              break
            case 1:
              item.images = require('../assets/shoppingCart_active.png')
              this.$router.replace({
                path: '/homePage/shoppingCart?isTab=1'
              }).catch(err => { return err })
              this.resetSet()
              break
            case 2:
              item.images = require('../assets/myCenter_active.png')
              this.$router.replace({
                path: '/homePage/personHomePage?isTab=1'
              }).catch(err => { return err })
              this.resetSet()
              break
            case 3:
              break
          }
        } else {
          item.active = false
        }
      })
    },
    resetSet: function () {
      this.androidTabHeight(localStorage.getItem('tabHeight'))
    },
    androidTabHeight (value) {
      // Toast('成功请求，底部高度+底部菜单栏高度===' + this.tabHeight + parseInt(value))
      // 设置android 模态导航条
      // Toast('tabHeight======' + value)
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          this.tabHeight = 70
        } else {
          this.tabHeight = 50
        }
      } else {
        console.log("NAV tabHeight:",this.tabHeight)
        this.tabHeight = this.tabHeight + (parseInt(value)?parseInt(value):0) 
      }
      // console.log("NAV bottomNavigation高度updated:",this.$refs.bottomNavigation.offsetHeight,this.tabHeight)
    }
    
  },
  beforeRouteUpdate (to, from, next) {
    if (localStorage.getItem('isLogin') === '0') {
      if (to.path === '/homePage/login' || to.path === '/homePage/goodslist') {
        next()
      } else {
        next({
          path: '/homePage/login',
          query: {
            back: 1
          }
        })
      }
    } else {
      next()
    }
  },
  beforeDestroy () {
  },
  activated () {
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {

    } else {
    console.log('再执行一次')
    // if(this.$route.path==='/goodsdetail'){return false};
    this.ChangeTabGO(parseInt(localStorage.getItem('tab')),"activated")
    }
    this.checkLogin()
  },
  created () {
    this.checkLogin()
    window['backTohome'] = (result) => {
      this.backTohome()
    }
    window['destroyPage'] = (result) => {
      this.backTohome()
    }
    console.log(parseInt(localStorage.getItem('tab')))
    console.log(this.$route.path )
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      // this.ChangeTabGO(parseInt(localStorage.getItem('tab')))
    } else {
      //不知道为什么再从goodslist进入goodsdetail后会运行bottomNavigation组件  为什么?
      // if(this.$route.path==='/goodsdetail'){return false};
      this.ChangeTabGO(parseInt(localStorage.getItem('tab')),"created")
    }
    // 适配Android 底部导航
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      var _this = this
      window['androidTabHeight'] = (result) => {
        _this.androidTabHeight(result)
      }
      
      if (this.utils.isIphone() === true) {
        this.androidTabHeight('0')
      } else {
        this.androidTabHeight(window.zxzx.getNavigationBarHeight())
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#bottomNavigation {
  position: fixed;
  width: 100%;
  bottom: 0;
  font-size: 0;
  z-index: 500;
  box-shadow: 0px -1px 2px 0px rgba(84, 83, 83, 0.11);
  .itembox {
    height: 50px;
    width: 100%;
    background: #ffffff;
    display: flex;
    padding-top: 6.5px;
    .allItem {
      flex: 1;
      text-align: center;
      .ItemImg {
        display: block;
        margin: 0 auto;
        width: 20px;
        height: 20px;
        background-size: cover;
      }
      .ItemText {
        width: 100%;
        display: inline-block;
        font-size: 12px;
        color: #b6b6c4;
      }
    }
    .active {
      .ItemText {
        color: #c41335;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bottomNavigation.vue